export default __webpack_public_path__ + "acd12a55d782a02f4b6f0c0b7eedafbd.png";